import React from "react";
import ModalShell from "./ModalShell";

const SavedSearchesModal = ({ list, loading, onLoad, onDelete, onClose }) => (
  <ModalShell title="Saved searches" maxWidth={480} onClose={onClose}>
    <div className="jv2-modal-body" style={{ maxHeight: 380, overflowY: "auto", scrollbarWidth: "none" }}>
      {loading ? (
        <div style={{ display: "flex", justifyContent: "center", padding: "20px 0" }}>
          <div className="spinner-border" style={{ color: "#F75891" }} />
        </div>
      ) : list.length === 0 ? (
        <p style={{ textAlign: "center", color: "#8A9199", fontSize: 13, margin: 0 }}>No saved searches for this job yet.</p>
      ) : (
        list.map((item) => (
          <div key={item.id} className="saved-search-item-v2">
            <div className="saved-search-item-info">
              <strong>{item.name}</strong>
              <span>{item.summary}</span>
              <span className="saved-search-date">{new Date(item.created_at).toLocaleDateString()}</span>
            </div>
            <div className="saved-search-item-actions">
              <button type="button" className="saved-search-load-btn" onClick={() => onLoad(item)}>Load</button>
              <button type="button" className="saved-search-del-btn" onClick={() => onDelete(item.id)}>Delete</button>
            </div>
          </div>
        ))
      )}
    </div>
  </ModalShell>
);

export default SavedSearchesModal;
